import { gql } from '@apollo/client'

// A restaurant's manual delivery (backend: resolvers/manualDelivery.js).

export const MANUAL_DELIVERY_QUOTE = gql`
  query ManualDeliveryQuote($restaurantId: ID!, $latitude: Float!, $longitude: Float!) {
    manualDeliveryQuote(restaurantId: $restaurantId, latitude: $latitude, longitude: $longitude) {
      fee
      mode
      distanceMiles
      summary
      fallbackToPlatform
    }
  }
`

export const CREATE_MANUAL_DELIVERY = gql`
  mutation CreateManualDelivery($input: ManualDeliveryInput!) {
    createManualDelivery(input: $input) {
      _id
      orderId
      orderStatus
      dispatchTier
    }
  }
`

// The menu, the way the POS reads it: menu names first, then one menu's items
// with every selection rule the options picker needs.
export const PICKER_MENUS = gql`
  query PickerMenus($restaurantId: ID!) {
    advancedMenus(restaurantId: $restaurantId) {
      _id
      name
      isActive
      displayOrder
    }
  }
`

export const PICKER_MENU_ITEMS = gql`
  query PickerMenuItems($menuId: ID!) {
    advancedMenuItems(menuId: $menuId) {
      _id
      menuId
      name
      categoryName
      basePrice
      variantPrices
      isActive
      isAvailable
      is86ed
      displayOrder
      modifierGroups {
        _id
        name
        selectionType
        minSelections
        maxSelections
        isRequired
        additionalCost
        allowDuplicates
        maxDuplicates
        duplicatePricingMode
        displayOrder
        modifiers {
          _id
          memberType
          priceOverrideMode
          fixedPrice
          variantPrices
          isHidden
          displayOrder
          modifier { _id name }
          item { _id name }
        }
      }
      optionGroups {
        _id
        name
        choices
        selectionType
        isRequired
        displayOrder
      }
    }
  }
`
